export const ADD_ITEM = '[Client Order] Add created item on click Confirm Btn';
export const DELETE_ITEM = '[Client Order] Delete item on click Delete btn';
export const DELETE_ALL_ITEMS = '[Client Order] Delete items on success order send';

export const SET_EXPECTED_DATE = '[Client Order] Set expected produce date';
export const SET_DELIVERY_METHOD = '[Client Order] Set delivery method';
export const RESET_ADDITIONAL_INFO = '[Client Order] Reset additional info';

export const ADD_ORDER = '[Client Order] Add saved order to orders list'
export const SET_ORDERS = '[Client Order] Set orders list'

export const SET_ORDER_STATUS = '[Admin:Order Status] Set order status'
export const SET_ITEM_ORDER_STATUS = '[Admin:Order Item Status] Set item order status'
export const UPDATE_ORDER = '[Order update] Update order in db'

export function addItem(payload) {
  return {
    type: ADD_ITEM,
    payload: payload
  }
}

export function deleteItem(payload) {
  return {
    type: DELETE_ITEM,
    payload: payload
  }
}

export function deleteAllItems() {
  return {
    type: DELETE_ALL_ITEMS
  }
}

export function setExpectedDate(payload) {
  return {
    type: SET_EXPECTED_DATE,
    payload: payload
  }
}

export function setDeliveryMethod(payload) {
  return {
    type: SET_DELIVERY_METHOD,
    payload: payload
  }
}

export function resetAdditionalInfo() {
  return {
    type: RESET_ADDITIONAL_INFO
  }
}

export function addOrder(payload) {
  return {
    type: ADD_ORDER,
    payload: payload
  }
}

export function setOrderStatus(payload) {
  return {
    type: SET_ORDER_STATUS,
    payload: payload
  }
}

export function setItemOrderStatus(payload) {
  return {
    type: SET_ITEM_ORDER_STATUS,
    payload: payload
  }
}

export function setOrders(payload) {
  return {
    type: SET_ORDERS,
    payload: payload
  }
}

export function updateOrder(payload) {
  return {
    type: UPDATE_ORDER,
    payload: payload
  }
}



